const scrollElm = (function () {
  if (document.scrollingElement) return document.scrollingElement;
  if (navigator.userAgent.indexOf('WebKit') != -1) return 'body';
  return document.documentElement;
})();

$(function(){
  //スムーススクロール
  $('a[href^="#"]').on("click", function(){
    const speed = 500;
    const href= $(this).attr("href");
    const target = $(href == "#" || href == "" ? 'html' : href);
    const position = target.offset().top;
    $(scrollElm).animate({scrollTop:position}, speed, "swing");
    return false;
  });

  //ヘッダー横移動
  const $elem = $(".header");
  $(window).on("scroll", function() {
    $elem.css("left", -window.scrollX + 'px');
  });

  //ハンバーガーメニュー操作
  (function(){
    let pos; //スクロールトップの値
    const $elem = $(".js-menu-elem");
    const device = $elem.data("device");
    $(".js-menu").on("click", function(){
      if($elem.is(":visible")) {
        $elem.fadeOut(300);
        if(device == "sp") {
          $("body").removeClass("is-fixed").css({"top": 0});
          window.scrollTo(0, pos);
        }
      } else {
        $elem.fadeIn(300);
        if(device == "sp") {
          pos = $(window).scrollTop();
          $("body").addClass("is-fixed").css({"top": -pos});
        }
      }
      return false;
    });
    $(".js-menu-close").on("click", function(){
      $elem.fadeOut(300);
      if(device == "sp") {
        $("body").removeClass("is-fixed").css({"top": 0});
        window.scrollTo(0, pos);
      }
    });
    if(device == "pc") {
      $(document).on("click", function(){
        if($elem.is(":visible")) {
          $elem.fadeOut(300);
        }
      });
      $(".js-menu-elem").on("click", function(e){
        e.stopPropagation();
      });
    }
  })();

  //フリーワードのアイコン挙動
  function freewordFocusIn() {
    const $elem = $(this).parents(".js-freeword-status");
    $elem.addClass("is-focus");
  }
  function freewordFocusOut() {
    const $elemInput = $(this);
    const $elem = $(this).parents(".js-freeword-status");
    $elem.removeClass("is-focus");
    if($elemInput.val() != "") {
      $elem.addClass("is-entered");
    } else {
      $elem.removeClass("is-entered");
    }
  }

  $(".js-freeword-status input").on("focus", freewordFocusIn);
  $(".js-freeword-status input").on("blur", freewordFocusOut);


  //アコーディオン
  function accordion() {
    const $elemButton = $(this);
    const $elem = $("#" + $elemButton.attr("aria-controls"));
    const expand = $elemButton.attr("aria-expanded");
    if(expand == "true") {
      $elem.slideUp(500);
      $elemButton.attr("aria-expanded", false);
    } else {
      $elem.slideDown(500);
      $elemButton.attr("aria-expanded", true);
    }
    return false;
  }

  $(".js-accordion-button").on("click", accordion);

  //フォームクリア
  $(".js-form-clear").on("click", function(){
    $("form[name='search']").find("textarea, :text, select").val("").end().find(":checked").prop("checked", false);
  });

  // 求人一覧　検索条件開閉（spのみ）
  $(".selectItem-toggle").on("click", function(){
    $(".selectItem").toggleClass("expanded");
  });

});
